"use client";
import { createGlobalStyle } from "styled-components";
import { globalTextStyles } from "../../foundation/typography/index.js";
const RegisterBilholdLightTheme = createGlobalStyle`
    .theme-bilhold {
  --moller-opacity-on-focus: 0.16;
  --moller-opacity-on-pressed: 0.16;
  --moller-opacity-on-hover: 0.08;
  --moller-opacity-percentage-16: 0.16;
  --moller-opacity-percentage-8: 0.08;
  --moller-elevation-high: 0px 0px 1px 0px #0000003d, 0px 2px 16px 0px #00000014, 0px 8px 48px 0px #0000000f;
  --moller-elevation-medium: 0px 0px 1px 0px #0000003d, 0px 4px 8px 0px #0000000a, 0px 8px 24px 0px #0000000f;
  --moller-elevation-low: 0px 0px 1px 0px #0000003d, 0px 1px 4px 0px #0000000a, 0px 4px 8px 0px #0000000f;
  --moller-elevation-none: 0px 0px 0px 0px #00000000;
  --moller-border-radius-full: 999px;
  --moller-border-radius-xx-large: 16px;
  --moller-border-radius-x-large: 12px;
  --moller-border-radius-large: 8px;
  --moller-border-radius-medium: 4px;
  --moller-border-radius-small: 2px;
  --moller-border-radius-none: 0px;
  --moller-stroke-large: 4px;
  --moller-stroke-medium: 2px;
  --moller-stroke-small: 1px;
  --moller-stroke-x-small: 0.5px;
  --moller-type-compact-notice-text-case: none;
  --moller-type-compact-notice-text-decoration: none;
  --moller-type-compact-notice-paragraph-spacing: 0.75rem;
  --moller-type-compact-notice-letter-spacing: 0;
  --moller-type-compact-notice-font-size: 0.75rem;
  --moller-type-compact-notice-line-height: 1.4;
  --moller-type-compact-notice-font-weight: 600;
  --moller-type-compact-notice-font-family: Figtree;
  --moller-type-compact-label-text-case: none;
  --moller-type-compact-label-text-decoration: none;
  --moller-type-compact-label-paragraph-spacing: 0.625rem;
  --moller-type-compact-label-letter-spacing: 0;
  --moller-type-compact-label-font-size: 0.625rem;
  --moller-type-compact-label-line-height: 1.4;
  --moller-type-compact-label-font-weight: 400;
  --moller-type-compact-label-font-family: Figtree;
  --moller-type-compact-action-text-case: none;
  --moller-type-compact-action-text-decoration: none;
  --moller-type-compact-action-paragraph-spacing: 0.875rem;
  --moller-type-compact-action-letter-spacing: 0;
  --moller-type-compact-action-font-size: 0.875rem;
  --moller-type-compact-action-line-height: 1.4;
  --moller-type-compact-action-font-weight: 600;
  --moller-type-compact-action-font-family: Figtree;
  --moller-type-small-description-text-case: none;
  --moller-type-small-description-text-decoration: none;
  --moller-type-small-description-paragraph-spacing: 0.75rem;
  --moller-type-small-description-letter-spacing: 0;
  --moller-type-small-description-font-size: 0.75rem;
  --moller-type-small-description-line-height: 1.4;
  --moller-type-small-description-font-weight: 400;
  --moller-type-small-description-font-family: Figtree;
  --moller-type-small-link-text-case: none;
  --moller-type-small-link-text-decoration: underline;
  --moller-type-small-link-paragraph-spacing: 1rem;
  --moller-type-small-link-letter-spacing: 0;
  --moller-type-small-link-font-size: 1rem;
  --moller-type-small-link-line-height: 1.4;
  --moller-type-small-link-font-weight: 400;
  --moller-type-small-link-font-family: Figtree;
  --moller-type-small-body-text-case: none;
  --moller-type-small-body-text-decoration: none;
  --moller-type-small-body-paragraph-spacing: 1rem;
  --moller-type-small-body-letter-spacing: 0;
  --moller-type-small-body-font-size: 1rem;
  --moller-type-small-body-line-height: 1.4;
  --moller-type-small-body-font-weight: 400;
  --moller-type-small-body-font-family: Figtree;
  --moller-type-small-lead-text-case: none;
  --moller-type-small-lead-text-decoration: none;
  --moller-type-small-lead-paragraph-spacing: 1.25rem;
  --moller-type-small-lead-letter-spacing: 0;
  --moller-type-small-lead-font-size: 1.25rem;
  --moller-type-small-lead-line-height: 1.4;
  --moller-type-small-lead-font-weight: 400;
  --moller-type-small-lead-font-family: Figtree;
  --moller-type-small-overline-text-case: uppercase;
  --moller-type-small-overline-text-decoration: none;
  --moller-type-small-overline-paragraph-spacing: 1.125rem;
  --moller-type-small-overline-letter-spacing: 0;
  --moller-type-small-overline-font-size: 0.75rem;
  --moller-type-small-overline-line-height: 1.4;
  --moller-type-small-overline-font-weight: 600;
  --moller-type-small-overline-font-family: Figtree;
  --moller-type-small-subtitle-text-case: none;
  --moller-type-small-subtitle-text-decoration: none;
  --moller-type-small-subtitle-paragraph-spacing: 1.5rem;
  --moller-type-small-subtitle-letter-spacing: 0;
  --moller-type-small-subtitle-font-size: 1rem;
  --moller-type-small-subtitle-line-height: 1.4;
  --moller-type-small-subtitle-font-weight: 600;
  --moller-type-small-subtitle-font-family: Figtree;
  --moller-type-small-headline-text-case: none;
  --moller-type-small-headline-text-decoration: none;
  --moller-type-small-headline-paragraph-spacing: 2.25rem;
  --moller-type-small-headline-letter-spacing: 0;
  --moller-type-small-headline-font-size: 1.5rem;
  --moller-type-small-headline-line-height: 1.4;
  --moller-type-small-headline-font-weight: 600;
  --moller-type-small-headline-font-family: Figtree;
  --moller-type-small-display-text-case: none;
  --moller-type-small-display-text-decoration: none;
  --moller-type-small-display-paragraph-spacing: 3rem;
  --moller-type-small-display-letter-spacing: 0;
  --moller-type-small-display-font-size: 2rem;
  --moller-type-small-display-line-height: 1.4;
  --moller-type-small-display-font-weight: 600;
  --moller-type-small-display-font-family: Figtree;
  --moller-type-medium-description-text-case: none;
  --moller-type-medium-description-text-decoration: none;
  --moller-type-medium-description-paragraph-spacing: 0.75rem;
  --moller-type-medium-description-letter-spacing: 0;
  --moller-type-medium-description-font-size: 0.75rem;
  --moller-type-medium-description-line-height: 1.4;
  --moller-type-medium-description-font-weight: 400;
  --moller-type-medium-description-font-family: Figtree;
  --moller-type-medium-link-text-case: none;
  --moller-type-medium-link-text-decoration: underline;
  --moller-type-medium-link-paragraph-spacing: 1rem;
  --moller-type-medium-link-letter-spacing: 0;
  --moller-type-medium-link-font-size: 1rem;
  --moller-type-medium-link-line-height: 1.4;
  --moller-type-medium-link-font-weight: 400;
  --moller-type-medium-link-font-family: Figtree;
  --moller-type-medium-body-text-case: none;
  --moller-type-medium-body-text-decoration: none;
  --moller-type-medium-body-paragraph-spacing: 1rem;
  --moller-type-medium-body-letter-spacing: 0;
  --moller-type-medium-body-font-size: 1rem;
  --moller-type-medium-body-line-height: 1.4;
  --moller-type-medium-body-font-weight: 400;
  --moller-type-medium-body-font-family: Figtree;
  --moller-type-medium-lead-text-case: none;
  --moller-type-medium-lead-text-decoration: none;
  --moller-type-medium-lead-paragraph-spacing: 1.5rem;
  --moller-type-medium-lead-letter-spacing: 0;
  --moller-type-medium-lead-font-size: 1.5rem;
  --moller-type-medium-lead-line-height: 1.4;
  --moller-type-medium-lead-font-weight: 400;
  --moller-type-medium-lead-font-family: Figtree;
  --moller-type-medium-overline-text-case: uppercase;
  --moller-type-medium-overline-text-decoration: none;
  --moller-type-medium-overline-paragraph-spacing: 1.5rem;
  --moller-type-medium-overline-letter-spacing: 0;
  --moller-type-medium-overline-font-size: 1rem;
  --moller-type-medium-overline-line-height: 1.4;
  --moller-type-medium-overline-font-weight: 600;
  --moller-type-medium-overline-font-family: Figtree;
  --moller-type-medium-subtitle-text-case: none;
  --moller-type-medium-subtitle-text-decoration: none;
  --moller-type-medium-subtitle-paragraph-spacing: 1.875rem;
  --moller-type-medium-subtitle-letter-spacing: 0;
  --moller-type-medium-subtitle-font-size: 1.25rem;
  --moller-type-medium-subtitle-line-height: 1.4;
  --moller-type-medium-subtitle-font-weight: 600;
  --moller-type-medium-subtitle-font-family: Figtree;
  --moller-type-medium-headline-text-case: none;
  --moller-type-medium-headline-text-decoration: none;
  --moller-type-medium-headline-paragraph-spacing: 2.625rem;
  --moller-type-medium-headline-letter-spacing: 0;
  --moller-type-medium-headline-font-size: 1.75rem;
  --moller-type-medium-headline-line-height: 1.4;
  --moller-type-medium-headline-font-weight: 600;
  --moller-type-medium-headline-font-family: Figtree;
  --moller-type-medium-display-text-case: none;
  --moller-type-medium-display-text-decoration: none;
  --moller-type-medium-display-paragraph-spacing: 4.5rem;
  --moller-type-medium-display-letter-spacing: 0;
  --moller-type-medium-display-font-size: 3rem;
  --moller-type-medium-display-line-height: 1.4;
  --moller-type-medium-display-font-weight: 600;
  --moller-type-medium-display-font-family: Figtree;
  --moller-type-default-notice-text-case: none;
  --moller-type-default-notice-text-decoration: none;
  --moller-type-default-notice-paragraph-spacing: 1rem;
  --moller-type-default-notice-letter-spacing: 0;
  --moller-type-default-notice-font-size: 1rem;
  --moller-type-default-notice-line-height: 1.4;
  --moller-type-default-notice-font-weight: 600;
  --moller-type-default-notice-font-family: Figtree;
  --moller-type-default-label-text-case: none;
  --moller-type-default-label-text-decoration: none;
  --moller-type-default-label-paragraph-spacing: 0.75rem;
  --moller-type-default-label-letter-spacing: 0;
  --moller-type-default-label-font-size: 0.75rem;
  --moller-type-default-label-line-height: 1.4;
  --moller-type-default-label-font-weight: 400;
  --moller-type-default-label-font-family: Figtree;
  --moller-type-default-action-text-case: none;
  --moller-type-default-action-text-decoration: none;
  --moller-type-default-action-paragraph-spacing: 1rem;
  --moller-type-default-action-letter-spacing: 0;
  --moller-type-default-action-font-size: 1rem;
  --moller-type-default-action-line-height: 1.4;
  --moller-type-default-action-font-weight: 600;
  --moller-type-default-action-font-family: Figtree;
  --moller-type-large-description-text-case: none;
  --moller-type-large-description-text-decoration: none;
  --moller-type-large-description-paragraph-spacing: 0.875rem;
  --moller-type-large-description-letter-spacing: 0;
  --moller-type-large-description-font-size: 0.875rem;
  --moller-type-large-description-line-height: 1.4;
  --moller-type-large-description-font-weight: 400;
  --moller-type-large-description-font-family: Figtree;
  --moller-type-large-link-text-case: none;
  --moller-type-large-link-text-decoration: underline;
  --moller-type-large-link-paragraph-spacing: 1rem;
  --moller-type-large-link-letter-spacing: 0;
  --moller-type-large-link-font-size: 1rem;
  --moller-type-large-link-line-height: 1.4;
  --moller-type-large-link-font-weight: 400;
  --moller-type-large-link-font-family: Figtree;
  --moller-type-large-body-text-case: none;
  --moller-type-large-body-text-decoration: none;
  --moller-type-large-body-paragraph-spacing: 1rem;
  --moller-type-large-body-letter-spacing: 0;
  --moller-type-large-body-font-size: 1rem;
  --moller-type-large-body-line-height: 1.4;
  --moller-type-large-body-font-weight: 400;
  --moller-type-large-body-font-family: Figtree;
  --moller-type-large-lead-text-case: none;
  --moller-type-large-lead-text-decoration: none;
  --moller-type-large-lead-paragraph-spacing: 1.75rem;
  --moller-type-large-lead-letter-spacing: 0;
  --moller-type-large-lead-font-size: 1.75rem;
  --moller-type-large-lead-line-height: 1.4;
  --moller-type-large-lead-font-weight: 400;
  --moller-type-large-lead-font-family: Figtree;
  --moller-type-large-overline-text-case: uppercase;
  --moller-type-large-overline-text-decoration: none;
  --moller-type-large-overline-paragraph-spacing: 1.5rem;
  --moller-type-large-overline-letter-spacing: 0;
  --moller-type-large-overline-font-size: 1rem;
  --moller-type-large-overline-line-height: 1.4;
  --moller-type-large-overline-font-weight: 600;
  --moller-type-large-overline-font-family: Figtree;
  --moller-type-large-subtitle-text-case: none;
  --moller-type-large-subtitle-text-decoration: none;
  --moller-type-large-subtitle-paragraph-spacing: 2.25rem;
  --moller-type-large-subtitle-letter-spacing: 0;
  --moller-type-large-subtitle-font-size: 1.5rem;
  --moller-type-large-subtitle-line-height: 1.4;
  --moller-type-large-subtitle-font-weight: 600;
  --moller-type-large-subtitle-font-family: Figtree;
  --moller-type-large-headline-text-case: none;
  --moller-type-large-headline-text-decoration: none;
  --moller-type-large-headline-paragraph-spacing: 3rem;
  --moller-type-large-headline-letter-spacing: 0;
  --moller-type-large-headline-font-size: 2rem;
  --moller-type-large-headline-line-height: 1.4;
  --moller-type-large-headline-font-weight: 600;
  --moller-type-large-headline-font-family: Figtree;
  --moller-type-large-display-text-case: none;
  --moller-type-large-display-text-decoration: none;
  --moller-type-large-display-paragraph-spacing: 5.25rem;
  --moller-type-large-display-letter-spacing: 0;
  --moller-type-large-display-font-size: 3.5rem;
  --moller-type-large-display-line-height: 1.4;
  --moller-type-large-display-font-weight: 600;
  --moller-type-large-display-font-family: Figtree;
  --moller-keycolor-interactive: #524ff0;
  --moller-keycolor-info: #0963EC;
  --moller-keycolor-success: #0E7925;
  --moller-keycolor-warning: #B55700;
  --moller-keycolor-error: #CD1F00;
  --moller-keycolor-neutral-variant: #ACB0B9;
  --moller-keycolor-neutral: #BFC2C8;
  --moller-keycolor-tertiary-variant: #E1E4EB;
  --moller-keycolor-tertiary: #E1E4EB;
  --moller-keycolor-secondary: #E1E4EB;
  --moller-keycolor-primary: #3B404B;
  --moller-size-4xl: 64px;
  --moller-size-3xl: 48px;
  --moller-size-xxl: 40px;
  --moller-size-xl: 32px;
  --moller-size-l: 24px;
  --moller-size-m: 20px;
  --moller-size-s: 16px;
  --moller-size-xs: 12px;
  --moller-size-xxs: 8px;
  --moller-size-base: 4px;
  --moller-spacing-3xl: 48px;
  --moller-spacing-xxl: 40px;
  --moller-spacing-xl: 32px;
  --moller-spacing-l: 24px;
  --moller-spacing-m: 20px;
  --moller-spacing-s: 16px;
  --moller-spacing-xs: 12px;
  --moller-spacing-xxs: 8px;
  --moller-spacing-base: 4px;
  --moller-spacing-none: 0px;
  --moller-radius-checkbox: 0px;
  --moller-radius-feedback: 4px;
  --moller-radius-overlay: 8px;
  --moller-radius-picker: 4px;
  --moller-radius-input: 4px;
  --moller-radius-card: 4px;
  --moller-radius-button: 4px;
  --moller-color-highlight: #dddcff;
  --moller-color-interactive: #524ff0;
  --moller-color-on-info-container: #000d40;
  --moller-color-info-container: #e0f0ff;
  --moller-color-on-info: #ffffff;
  --moller-color-info: #0963ec;
  --moller-color-on-success-container: #0e2902;
  --moller-color-success-container: #dbf3df;
  --moller-color-on-success: #ffffff;
  --moller-color-success: #0e7925;
  --moller-color-on-warning-container: #3d1400;
  --moller-color-warning-container: #fff8db;
  --moller-color-on-warning: #000000;
  --moller-color-warning: #b55700;
  --moller-color-on-error-container: #360b03;
  --moller-color-error-container: #ffe1e1;
  --moller-color-on-error: #ffffff;
  --moller-color-error: #cd1f00;
  --moller-color-disabled-variant: #ffffff;
  --moller-color-on-surface: #000000;
  --moller-color-surface: #ffffff;
  --moller-color-on-inverse-background: #ffffff;
  --moller-color-inverse-background: #000000;
  --moller-color-on-background: #000000;
  --moller-color-on-tertiary-variant: #000000;
  --moller-color-tertiary-variant: #e1e4eb;
  --moller-color-on-tertiary-container: #22252e;
  --moller-color-tertiary-container: #f7f8fa;
  --moller-color-on-tertiary: #000000;
  --moller-color-tertiary: #e1e4eb;
  --moller-color-on-secondary-container: #22252e;
  --moller-color-on-secondary: #000000;
  --moller-color-secondary: #e1e4eb;
  --moller-color-on-primary: #ffffff;
  --moller-color-on-disabled-variant: #bfc2c8;
  --moller-color-on-surface-variant: #000000;
  --moller-color-surface-variant: #fbfbfd;
  --moller-color-on-loader: #e2e4e9;
  --moller-color-loader: #ebedf1;
  --moller-color-outline: #d0d3d9;
  --moller-color-on-disabled: #8c929e;
  --moller-color-disabled: #d9dce1;
  --moller-color-background: #f5f6f8;
  --moller-color-secondary-container: #f4f6f9;
  --moller-color-on-primary-container: #ffffff;
  --moller-color-primary-container: #5b616b;
  --moller-color-primary: #22252e;
  --moller-typeface-text-decoration-strikethrough: line-through;
  --moller-typeface-text-decoration-line: underline;
  --moller-typeface-text-decoration-none: none;
  --moller-typeface-text-case-lowercase: lowercase;
  --moller-typeface-text-case-uppercase: uppercase;
  --moller-typeface-text-case-none: none;
  --moller-typeface-letter-spacing-none: 0;
  --moller-typeface-size-4xl: 3.5rem;
  --moller-typeface-size-3xl: 3rem;
  --moller-typeface-size-xxl: 2rem;
  --moller-typeface-size-xl: 1.75rem;
  --moller-typeface-size-l: 1.5rem;
  --moller-typeface-size-m: 1.25rem;
  --moller-typeface-size-base: 1rem;
  --moller-typeface-size-s: 0.875rem;
  --moller-typeface-size-xs: 0.75rem;
  --moller-typeface-size-xxs: 0.625rem;
  --moller-typeface-line-height: 1.4;
  --moller-typeface-brand-display: Figtree;
  --moller-typeface-weight-bold: 600;
  --moller-typeface-weight-regular: 400;
  --moller-typeface-brand: Figtree;
  --moller-palette-interactive-95: #dddcff;
  --moller-palette-interactive-90: #bebcff;
  --moller-palette-interactive-80: #a2a0ff;
  --moller-palette-interactive-70: #8F87FF;
  --moller-palette-interactive-60: #7471ff;
  --moller-palette-interactive-50: #615EFC;
  --moller-palette-interactive-40: #524ff0;
  --moller-palette-interactive-30: #3e3bb4;
  --moller-palette-interactive-20: #292878;
  --moller-palette-interactive-10: #15143c;
  --moller-palette-info-95: #E0F0FF;
  --moller-palette-info-90: #B6DBFF;
  --moller-palette-info-80: #92C5FF;
  --moller-palette-info-70: #6DADFF;
  --moller-palette-info-60: #4994FF;
  --moller-palette-info-50: #247AFF;
  --moller-palette-info-40: #0963EC;
  --moller-palette-info-30: #0040BF;
  --moller-palette-info-20: #002380;
  --moller-palette-info-10: #000D40;
  --moller-palette-success-95: #DBF3DF;
  --moller-palette-success-90: #B9E5C0;
  --moller-palette-success-80: #99D5A3;
  --moller-palette-success-70: #7AC487;
  --moller-palette-success-60: #5fa96e;
  --moller-palette-success-50: #439153;
  --moller-palette-success-40: #0E7925;
  --moller-palette-success-30: #1c6b20;
  --moller-palette-success-20: #124D09;
  --moller-palette-success-10: #0E2902;
  --moller-palette-warning-95: #fff8db;
  --moller-palette-warning-90: #fff0b6;
  --moller-palette-warning-80: #ffe692;
  --moller-palette-warning-70: #FFD771;
  --moller-palette-warning-60: #FFCA41;
  --moller-palette-warning-50: #FFAB00;
  --moller-palette-warning-40: #B55700;
  --moller-palette-warning-30: #A54600;
  --moller-palette-warning-20: #6B2400;
  --moller-palette-warning-10: #3D1400;
  --moller-palette-error-95: #FFE1E1;
  --moller-palette-error-90: #ffbaba;
  --moller-palette-error-80: #ff9392;
  --moller-palette-error-70: #ff756d;
  --moller-palette-error-60: #f85a49;
  --moller-palette-error-50: #ea4224;
  --moller-palette-error-40: #CD1F00;
  --moller-palette-error-30: #a2210a;
  --moller-palette-error-20: #6c1607;
  --moller-palette-error-10: #360b03;
  --moller-palette-white: #ffffff;
  --moller-palette-black: #000000;
  --moller-palette-tertiary-variant-95: #FBFBFD;
  --moller-palette-tertiary-variant-90: #F7F8FA;
  --moller-palette-tertiary-variant-80: #F4F6F9;
  --moller-palette-tertiary-variant-70: #EFF2F6;
  --moller-palette-tertiary-variant-60: #EBEEF4;
  --moller-palette-tertiary-variant-50: #E8EBF1;
  --moller-palette-tertiary-variant-40: #E1E4EB;
  --moller-palette-tertiary-variant-30: #ACB0B9;
  --moller-palette-tertiary-variant-20: #6B717C;
  --moller-palette-tertiary-variant-10: #22252E;
  --moller-palette-tertiary-95: #FBFBFD;
  --moller-palette-tertiary-90: #F7F8FA;
  --moller-palette-tertiary-80: #F4F6F9;
  --moller-palette-tertiary-70: #EFF2F6;
  --moller-palette-tertiary-60: #EBEEF4;
  --moller-palette-tertiary-50: #E8EBF1;
  --moller-palette-tertiary-40: #E1E4EB;
  --moller-palette-tertiary-30: #ACB0B9;
  --moller-palette-tertiary-20: #6B717C;
  --moller-palette-tertiary-10: #22252E;
  --moller-palette-secondary-95: #FBFBFD;
  --moller-palette-secondary-90: #F7F8FA;
  --moller-palette-secondary-80: #F4F6F9;
  --moller-palette-secondary-70: #EFF2F6;
  --moller-palette-secondary-60: #EBEEF4;
  --moller-palette-secondary-50: #E8EBF1;
  --moller-palette-secondary-40: #E1E4EB;
  --moller-palette-secondary-30: #ACB0B9;
  --moller-palette-secondary-20: #6B717C;
  --moller-palette-secondary-10: #22252E;
  --moller-palette-neutral-variant-95: #F5F6F8;
  --moller-palette-neutral-variant-90: #EBEDF1;
  --moller-palette-neutral-variant-80: #E2E4E9;
  --moller-palette-neutral-variant-70: #D9DCE1;
  --moller-palette-neutral-variant-60: #D0D3D9;
  --moller-palette-neutral-variant-50: #BFC2C8;
  --moller-palette-neutral-variant-40: #ACB0B9;
  --moller-palette-neutral-variant-30: #8C929E;
  --moller-palette-neutral-variant-20: #6B717C;
  --moller-palette-neutral-variant-10: #22252E;
  --moller-palette-neutral-95: #F5F6F8;
  --moller-palette-neutral-90: #EBEDF1;
  --moller-palette-neutral-80: #E2E4E9;
  --moller-palette-neutral-70: #D9DCE1;
  --moller-palette-neutral-60: #D0D3D9;
  --moller-palette-neutral-50: #BFC2C8;
  --moller-palette-neutral-40: #ACB0B9;
  --moller-palette-neutral-30: #8C929E;
  --moller-palette-neutral-20: #6B717C;
  --moller-palette-neutral-10: #22252E;
  --moller-palette-primary-95: #ACB0B9;
  --moller-palette-primary-90: #8C929E;
  --moller-palette-primary-80: #7C818D;
  --moller-palette-primary-70: #6B717C;
  --moller-palette-primary-60: #5B616B;
  --moller-palette-primary-50: #4C505A;
  --moller-palette-primary-40: #3B404B;
  --moller-palette-primary-30: #2A2E38;
  --moller-palette-primary-20: #22252E;
  --moller-palette-primary-10: #111315;
  ${globalTextStyles}
    }
`;
export {
  RegisterBilholdLightTheme
};
